
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { saveMixin } from "@/mixins/saveMixin";
import { contentMixin } from "@/components/template-transfer-pc/template/mixins/contentMixin";
import MainHeader from "@/components/main-header.vue";
import TemplateContent from "@/components/template-transfer-pc/template/template-content.vue";
import {
  GetTemDetail,
  PostCepingContent,
  GetPatientDetail,
  GetContentDetail,
  EditContent,
} from "@/request/common";
import { getCurrentTime } from "@/utils/base";
@Component({
  components: {
    MainHeader,
    TemplateContent,
  },
})
export default class Name extends mixins(saveMixin, contentMixin) {
  private type: any = "";
  private patient_id: any = "";
  private template_id: any = "";
  private content_id: any = "";
  private template: any = {};
  private patient: any = {};
  private disabledDate: any = this.endDate();
  private get href() {
    return window.location.href;
  }
  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }
  private goReport(id: any) {
    this.$router.push({
      path: "/main/report/ceping-report",
      query: {
        ids: JSON.stringify([id]),
      },
    });
  }
  private edit() {
    this.$store.commit("updateIfCompose", true);
  }
  private updateWholeTem(e: any) {
    this.data.data = e;
    this.$forceUpdate();
  }
  private sizhenSaveContent() {
    this.save();
  }
  private updateContent(e: any) {
    this.data = e;
  }
  save() {
    return new Promise((resolve, reject) => {
      (this.$refs.templateContent as any).savePre().then((res: any) => {
        if (res) {
          // 必填验证成功
          const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
          });
          if (this.content_id || this.data.id) {
            EditContent(
              this,
              this.content_id || this.data.id,
              this.data,
              loading
            ).then((res: any) => {
              this.$message.success("保存成功！");
              this.$store.commit("updateIfCompose", false);
              this.data = res.data;
              this.scrollToTop();
              // this.getData();
              resolve(true);
            });
          } else {
            if (!this.data.related_type) {
              this.data.related_type = this.type;
            }
            PostCepingContent(this, this.data, loading).then((res: any) => {
              this.$message.success("保存成功！");
              this.$store.commit("updateIfCompose", false);
              // this.$router.back();
              this.getData(res.data.id);
              resolve(res);
            });
          }
        } else {
          // 必填验证失败
        }
      });
    });
  }
  private getTemplate() {
    if (!this.template_id) {
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTemDetail(this, this.template_id, loading)
      .then((res: any) => {
        loading.close();
        this.template = res.data;
        if (!this.content_id) {
          const d: any = JSON.parse(JSON.stringify(res.data));
          this.data = {
            patient: this.patient_id,
            template: d,
            data: d.fields,
            collect_time: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
          };
          this.$forceUpdate();
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private getData(id?: any) {
    if ((!this.content_id || this.data.id) && !id) {
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetContentDetail(this, this.content_id || id, loading)
      .then((res: any) => {
        loading.close();
        // 模拟数据
        // if (res.data.template.name == "舌象数据") {
        //   if (!res.data.report) {
        //     res.data.report = {};
        //   }
        //   if (!res.data.report["舌色参数"]) {
        //     res.data.report["舌色参数"] = [
        //       ["56.59", "57.61", "41.94", "57.28", "56.66", "59.57"],
        //       ["30.30", "30.64", "25.89", "29.19", "29.83", "32.85"],
        //       ["14.22", "14.34", "14.46", "14.05", "14.00", "14.32"],
        //       ["淡红", "", "", "", "", ""],
        //     ];
        //     res.data.report["苔色参数"] = [
        //       ["56.02", "58.69", "50.95", "58.31", "58.50", "58.55"],
        //       ["25.85", "26.81", "24.65", "25.34", "26.00", "27.03"],
        //       ["17.15", "17.41", "17.75", "15.70", "15.93", "14.31"],
        //       ["苔白", "", "", "", "", ""],
        //     ];
        //     res.data.report["舌象信息输出"] = [
        //       "淡红",
        //       "无",
        //       "无",
        //       "苔白",
        //       "薄",
        //       "无",
        //       "无",
        //       "无",
        //       "适中",
        //       "有",
        //       "无",
        //       "有",
        //     ];
        //   }
        // }
        // if (res.data.template.name == "面象数据") {
        //   if (!res.data.report) {
        //     res.data.report = {};
        //     res.data.report["面色唇色参数"] = [
        //       ["57.68", "53.93", "51.97", "51.97", "51.94", "58.37", "47.64"],
        //       ["24.59", "21.62", "12.88", "12.88", "12.24", "25.22", "35.35"],
        //       ["22.24", "22.98", "10.96", "10.96", "11.21", "22.52", "16.18"],
        //       ["面色赤", "", "", "", "", "", "唇色红"],
        //     ];
        //     res.data.report["面象信息输出"] = [
        //       "面色赤",
        //       "无",
        //       "无",
        //       "少量光泽",
        //       "唇色红",
        //     ];
        //   }
        // }
        // if (res.data.template.name == "脉象数据") {
        //   if (!res.data.report) {
        //     res.data.result="中"
        //     res.data.report = {};
        //     res.data.report["右手分段压脉图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d_12460_2_subsetionpulseimage.jpg";
        //     res.data.report["右手最佳压力脉图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d-12460-r.jpg";
        //     res.data.report["右手连续脉图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d_12460_2_rhythmimage.jpg";
        //     res.data.report["右手脉象p-h趋势图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d_12460_2_trendimage.jpg";
        //     res.data.report["左手分段压脉图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d_12460_2_subsetionpulseimage.jpg";
        //     res.data.report["左手最佳压力脉图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d-12460-r.jpg";
        //     res.data.report["左手连续脉图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d_12460_2_rhythmimage.jpg";
        //     res.data.report["左手脉象p-h趋势图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d_12460_2_trendimage.jpg";

        //     res.data.report["左手最佳脉象图参数"] = {
        //       A: 123.271,
        //       Ad: 48.625,
        //       As: 74.646,
        //       h1: 16.64,
        //       h2: 10.739,
        //       h3: 9.604,
        //       "h3/h1": 0.5772,
        //       h4: 7.033,
        //       "h4/h1": 0.4227,
        //       h5: 1.125,
        //       "h5/h1": 0.0676,
        //       t: 0.831,
        //       t1: 0.114,
        //       "t1/t": 0.1372,
        //       t2: 0.194,
        //       t3: 0.225,
        //       t4: 0.3,
        //       t5: 0.53,
        //       "t5/t4": 1.7667,
        //       w1: 0.124,
        //       "w1/t": 0.1492,
        //       w2: 0.082,
        //       "w2/t": 0.0987,
        //     };
        //     res.data.report["左手脉象信息输出"] = {
        //       流利度: "无滑、涩特征",
        //       紧张度: "无弦、紧特征",
        //       脉位: "沉",
        //       脉力: "中",
        //       脉名: "脉浮而结",
        //       脉率: "慢(72times/min)",
        //       脉节律: "不齐",
        //     };
        //     res.data.report["右手最佳脉象图参数"] = {
        //       A: 123.271,
        //       Ad: 48.625,
        //       As: 74.646,
        //       h1: 16.64,
        //       h2: 10.739,
        //       h3: 9.604,
        //       "h3/h1": 0.5772,
        //       h4: 7.033,
        //       "h4/h1": 0.4227,
        //       h5: 1.125,
        //       "h5/h1": 0.0676,
        //       t: 0.831,
        //       t1: 0.114,
        //       "t1/t": 0.1372,
        //       t2: 0.194,
        //       t3: 0.225,
        //       t4: 0.3,
        //       t5: 0.53,
        //       "t5/t4": 1.7667,
        //       w1: 0.124,
        //       "w1/t": 0.1492,
        //       w2: 0.082,
        //       "w2/t": 0.0987,
        //     };
        //     res.data.report["右手脉象信息输出"] = {
        //       流利度: "无滑、涩特征",
        //       紧张度: "无弦、紧特征",
        //       脉位: "沉",
        //       脉力: "中",
        //       脉名: "脉浮而结",
        //       脉率: "慢(72times/min)",
        //       脉节律: "不齐",
        //     };
        //   }
        // }
        this.data = res.data;
        this.$forceUpdate();
        this.scrollToTop();
      })
      .catch(() => {
        loading.close();
      });
  }
  private getPatientData() {
    if (!this.patient_id) {
      return;
    }
    GetPatientDetail(this, this.patient_id).then((res: any) => {
      this.patient = res.data;
    });
  }
  mounted() {
    if (this.$route.query.patient_id) {
      this.patient_id = this.$route.query.patient_id;
      this.getPatientData();
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.template_id) {
      this.template_id = this.$route.query.template_id;
      this.getTemplate();
    }
    if (this.$route.query.content_id) {
      this.content_id = this.$route.query.content_id;
      this.getData();
    }
  }
}
